export const contentButtonsDataLayer = {
  category: 'content_button',
  actions: {
    RETURN_TO_HOME: 'return to home',
    SHOW_MORE: 'show me more',
    SHOW_LESS: 'show me less',
  },
};
